document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.custom-gallery');
  if (!gallery) return;

  const mainImage = gallery.querySelector('.main-image');
  const thumbnailsContainer = gallery.querySelector('.thumbnails');
  const thumbnails = Array.from(thumbnailsContainer?.querySelectorAll('img') || []);
  const btnPrev = gallery.querySelector('.prev');
  const btnNext = gallery.querySelector('.next');

  if (!mainImage || thumbnails.length === 0) return;

  let currentIndex = 0;
  let touchStartX = null;
  let autoplayTimer = null;
  let resumeTimer = null;

  // Configurazione autoplay
  const AUTOPLAY_INTERVAL = 5000; // 5 secondi
  const RESUME_DELAY = 10000;     // 10 secondi di inattività prima di riprendere
  const SWIPE_THRESHOLD = 30;     // px

  /**
   * Aggiorna l'immagine principale e lo stato attivo
   */
  function activate(index) {
    currentIndex = (index + thumbnails.length) % thumbnails.length;
    const thumb = thumbnails[currentIndex];
    if (!thumb) return;

    if (thumb.dataset.large) {
      mainImage.src = thumb.dataset.large;
    }
    mainImage.alt = thumb.alt || '';

    thumbnails.forEach(t => {
      t.classList.remove('active');
      t.removeAttribute('aria-current');
    });
    thumb.classList.add('active');
    thumb.setAttribute('aria-current', 'true');
  }

  /**
   * Scorri avanti o indietro di uno
   */
  function shift(step) {
    activate(currentIndex + step);
  }

  /**
   * Gestione touch/swipe
   */
  mainImage.addEventListener('pointerdown', e => {
    touchStartX = e.clientX;
  });
  mainImage.addEventListener('pointerup', e => {
    if (touchStartX === null) return;
    const deltaX = e.clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(deltaX) >= SWIPE_THRESHOLD) {
      shift(deltaX < 0 ? 1 : -1);
      pauseAutoplay();
    }
  });

  /**
   * Eventi click thumbnails (delegation)
   */
  thumbnailsContainer?.addEventListener('click', e => {
    const target = e.target.closest('img');
    if (!target) return;
    const index = thumbnails.indexOf(target);
    if (index >= 0) {
      activate(index);
      pauseAutoplay();
    }
  });

  /**
   * Eventi click bottoni
   */
  btnPrev?.addEventListener('click', () => {
    shift(-1);
    pauseAutoplay();
  });
  btnNext?.addEventListener('click', () => {
    shift(1);
    pauseAutoplay();
  });

  /**
   * Autoplay
   */
  function startAutoplay() {
    stopAutoplay(); // evita duplicati
    autoplayTimer = setInterval(() => shift(1), AUTOPLAY_INTERVAL);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function pauseAutoplay() {
    stopAutoplay();
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(startAutoplay, RESUME_DELAY);
  }

  // Avvia sulla prima immagine
  activate(0);
  startAutoplay(); // autoplay parte subito
});